import React from "react";
import Field from "./Field";
import FileUploadControl from "./FileUploadControl";
import { FileUploadFieldProps } from "./Types";

const FileUploadField: React.FC<FileUploadFieldProps> = ({ labelProps, controlProps, multiple,  visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <FileUploadControl {...controlProps} multiple={multiple} disabled={disabled} />
        </Field>
    );
}

export default FileUploadField;